import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Alert } from './Alert';

const StyledAlert = styled(Alert)`
  text-align: center;
  margin-top: 24px;
  margin-bottom: -60px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
`;

const AllCaps = styled.span`
  text-transform: uppercase;
`;

export const TestnetNotification = (): JSX.Element => {
  return (
    <StyledAlert variant="error" round="none" pad="small">
      <FormattedMessage
        defaultMessage="Warning: This is a staking launchpad for the {testnet}."
        values={{
          testnet: (
            <AllCaps>
              <FormattedMessage defaultMessage="testnet" />
            </AllCaps>
          ),
        }}
      />
    </StyledAlert>
  );
};
